import { render } from "./StallTables.vue?vue&type=template&id=567f6bd0"
import script from "./StallTables.vue?vue&type=script&lang=js"
export * from "./StallTables.vue?vue&type=script&lang=js"

import "./StallTables.vue?vue&type=style&index=0&id=567f6bd0&lang=css"
import "./StallTables.vue?vue&type=style&index=1&id=567f6bd0&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__